<template>
  <div class="configManageUserVue">
    <div class="col-md-10 col-sm-9 u-pad-all-25 c-common-box-shadow u-bg-color-fff">
        <div class="manage-powerusers">

            <h3 class="u-cmn-botmargin">Manage Power Users <span class="c-common-btn--inverse-icon-orange"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></h3>

            <div class="row">
                <!-- LEFT COLUMN: PU list -->
                <div class="col-md-4">
                    <div class="o-manageusers-checkbox c-margin-bottom-10">
                        <div class="manageusers-checkbox-head clearfix">
                            <div class="row">
                                <div class="col-md-7">
                                    <h4>Power Users:</h4>
                                    <div class="o-subtitleHeading">
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                <input type="checkbox" name="o4" v-model="selectType" @change="selectAll()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                        <label class="o-blue-regular-text">Select All</label>
                                    </div>
                                </div>
                                <div class="col-md-5 text-right">
                                    <a href="javascript: void(0)" @click="removePowerUser()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="manageusers-checkbox-body clearfix">
                            <div class="manageusers-checkbox-body-inner">
                                <div v-for="pu in powerUsersList" class="col-sm-12 o-powerUser-list">
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            {{pu.first_name+" "+pu.last_name}}
                                            <input type="checkbox" name="o4" :value="pu.id" checked="" v-model="selectedPowerUser">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CENTER COLUMN: Dropdown + arrows -->
                <div class="col-md-4">
                    <div class="pu-promote-center">
                        <h4 class="text-center">Select Employee:</h4>
                        <div class="pu-arrow-buttons">
                            <a href="javascript: void(0)" @click="promoteToPU()" class="c-solid-btn c-solid-btn--green pu-arrow-btn">
                                <i class="fa fa-arrow-left"></i> PU
                            </a>
                            <a href="javascript: void(0)" @click="promoteToPUMinus()" class="c-solid-btn c-solid-btn--green pu-arrow-btn">
                                PU-Minus <i class="fa fa-arrow-right"></i>
                            </a>
                        </div>
                        <div class="o-cutsomSelect o-cutsomSelect--poweruser o-multiselect-drop">
                            <el-select
                                v-model="selectedSteward"
                                filterable
                                remote
                                reserve-keyword
                                multiple
                                collapse-tags
                                style="width: 100%;"
                                placeholder="Select">
                                <el-option
                                  v-for="steward in stewardList"
                                  :key="steward.id"
                                  :label="steward.first_name + ' ' + steward.last_name"
                                  :value="steward.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <!-- RIGHT COLUMN: PU- list -->
                <div class="col-md-4">
                    <div class="o-manageusers-checkbox c-margin-bottom-10">
                        <div class="manageusers-checkbox-head clearfix">
                            <div class="row">
                                <div class="col-md-7">
                                    <h4>PU-Minus Users:</h4>
                                    <div class="o-subtitleHeading">
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                <input type="checkbox" name="o5" v-model="selectTypeMinus" @change="selectAllMinus()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                        <label class="o-blue-regular-text">Select All</label>
                                    </div>
                                </div>
                                <div class="col-md-5 text-right">
                                    <a href="javascript: void(0)" @click="removePowerUserMinus()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="manageusers-checkbox-body clearfix">
                            <div class="manageusers-checkbox-body-inner">
                                <div v-for="puMinus in powerUserMinusList" class="col-sm-12 o-powerUser-list">
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            {{puMinus.first_name+" "+puMinus.last_name}}
                                            <input type="checkbox" name="o5" :value="puMinus.id" checked="" v-model="selectedPowerUserMinus">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';
    export default {
        data() {
            return {
                powerUsersList: [],
                powerUserMinusList: [],
                stewardList: [],
                selectedSteward: [],
                selectedPowerUser: [],
                selectedPowerUserMinus: [],
                selectType: 0,
                selectTypeMinus: 0
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            promoteToPU() {
                if (this.selectedSteward.length != 0) {
                    service.post('employee/promoteToPowerUser', {
                            'employee_id': JSON.stringify(this.selectedSteward)
                        }, {
                            'Authorization': this.userToken,
                            'clientId': this.userClientID,
                        })
                        .then((res) => {
                            this.getInitialData();
                            this.selectedSteward = [];
                        }).catch((err) => {
                            console.log(err);
                        });
                }
            },
            promoteToPUMinus() {
                if (this.selectedSteward.length != 0) {
                    service.post('employee/promoteToPowerUserMinus', {
                            'employee_id': JSON.stringify(this.selectedSteward)
                        }, {
                            'Authorization': this.userToken,
                            'clientId': this.userClientID,
                        })
                        .then((res) => {
                            this.getInitialData();
                            this.selectedSteward = [];
                        }).catch((err) => {
                            console.log(err);
                        });
                }
            },
            removePowerUser() {
                if (this.selectedPowerUser.length != 0) {
                    service.post('employee/removeFromPowerUser', {
                            'employee_id': JSON.stringify(this.selectedPowerUser)
                        }, {
                            'Authorization': this.userToken,
                            'clientId': this.userClientID,
                        })
                        .then((res) => {
                            this.getInitialData();
                        }).catch((err) => {
                            console.log(err);
                        });
                }
            },
            removePowerUserMinus() {
                if (this.selectedPowerUserMinus.length != 0) {
                    service.post('employee/removeFromPowerUserMinus', {
                            'employee_id': JSON.stringify(this.selectedPowerUserMinus)
                        }, {
                            'Authorization': this.userToken,
                            'clientId': this.userClientID,
                        })
                        .then((res) => {
                            this.getInitialData();
                        }).catch((err) => {
                            console.log(err);
                        });
                }
            },
            getInitialData() {
                service.get('employee/getPowerUsers', {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.powerUsersList = res.data.result;
                    }).catch((err) => {
                        console.log(err);
                    });

                service.get('employee/getPowerUserMinusUsers', {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.powerUserMinusList = res.data.result;
                    }).catch((err) => {
                        console.log(err);
                    });

                service.get('employee/otherUsers', {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.stewardList = res.data.result;
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            selectAll() {
                this.selectedPowerUser = [];
                if (this.selectType == true) {
                    for (var i = 0; i < this.powerUsersList.length; i++) {
                        this.selectedPowerUser.push(this.powerUsersList[i].id);
                    }
                }
            },
            selectAllMinus() {
                this.selectedPowerUserMinus = [];
                if (this.selectTypeMinus == true) {
                    for (var i = 0; i < this.powerUserMinusList.length; i++) {
                        this.selectedPowerUserMinus.push(this.powerUserMinusList[i].id);
                    }
                }
            }
        },
        created() {
            this.getInitialData();
        }
    }
</script>
<style scoped>
    .pu-promote-center {
        text-align: center;
        padding-top: 10px;
    }
    .pu-arrow-buttons {
        display: flex;
        justify-content: center;
        gap: 15px;
        margin-top: 15px;
    }
    .pu-arrow-btn {
        min-width: 80px;
        text-align: center;
    }
</style>
